import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../../abstraction/auth.service';
import { IEmployee } from '../../../models/User';
import { ErrorHandlingService } from '../../../services/utils/error-handling.service';
import errors from '../../../utils/errorCodes';
import { Utils } from '../../../utils/Utils';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-add-employee-dialog',
  templateUrl: './add-employee-dialog.component.html',
  styleUrls: ['./add-employee-dialog.component.scss'],
})
export class AddEmployeeDialogComponent implements OnInit {
  formGroup: FormGroup;
  editMode = false;
  employees: IEmployee[] = [];
  cuit = '';
  constructor(
    public dialogRef: MatDialogRef<AddEmployeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { employeeToEdit?: IEmployee },
    private auth: AuthService,
    private dialog: MatDialog,
    private errorHandler: ErrorHandlingService,
  ) {
    this.formGroup = new FormGroup({
      cuit: new FormControl('', [Validators.required, this.cuitValidator.bind(this)]),
      isArs: new FormControl(true, [Validators.required]),
      salary: new FormControl('', [Validators.required, this.salaryValidator.bind(this)]),
    });

    if (data?.employeeToEdit) {
      this.editMode = true;
      this.formGroup.controls.cuit.setValue(data.employeeToEdit.userId.cuit);
      this.formGroup.controls.cuit.disable();

      this.formGroup.controls.isArs.setValue(data.employeeToEdit.isArs);
      this.formGroup.controls.isArs.disable();

      this.formGroup.controls.salary.setValue(
        Utils.parseNumberToCurrencyString(data.employeeToEdit.salary),
      );
    }
  }

  ngOnInit(): void {
    this.auth.employees.subscribe((employees) => {
      this.employees = employees;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addEmployee() {
    if (!this.formGroup.controls.salary.value || !+this.formGroup.controls.salary.value) {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Salario Inválido',
          content: 'El salario ingresado debe ser mayor a 0',
          isError: true,
        },
      });
      return;
    }

    if (!this.editMode) {
      if (
        this.employees.find(
          (employee) => employee.userId.cuit === this.formGroup.controls.cuit.value,
        )
      ) {
        this.formGroup.controls.cuit.setErrors({ employeeExist: true });
        return;
      }

      this.auth
        .addEmployee(
          this.formGroup.controls.cuit.value,
          +this.formGroup.controls.salary.value,
          <boolean>this.formGroup.controls.isArs.value,
        )
        .subscribe(
          () => {
            this.closeDialog();
          },
          (err: HttpErrorResponse) => {
            this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: this.errorHandler.handlePayrollError(err),
            });
          },
        );
    } else {
      this.auth
        .editEmployee(
          this.formGroup.controls.cuit.value,
          +this.formGroup.controls.salary.value,
          <boolean>this.formGroup.controls.isArs.value,
        )
        .subscribe(() => {
          this.closeDialog();
        });
    }
  }

  removeEmployee() {
    this.auth.removeEmployee(this.formGroup.controls.cuit.value).subscribe(() => {
      this.closeDialog();
    });
  }

  getErrorMessage(input: string): string {
    const keys = Object.keys(this.formGroup.controls[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  salaryValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (+control.value < 1) {
      return { minSalary: true };
    }
    return null;
  }

  cuitValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value.length !== 11) {
      return { cuilMin: true };
    }
    if (control.value === this.auth.loggedUser.cuit) {
      return { cuitSameAsOwn: true };
    }
    return null;
  }
}
